import { getInitialState, State } from "./state";
import { Actions, ActionTypes } from "./actions";

const initialState = getInitialState();

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionTypes.fetch:
      return {
        ...state,
        fetchStatus: "loading"
      };
    case ActionTypes.fetchSuccess:
      return {
        ...state,
        fetchStatus: "success",
        aggregations: action.payload.aggregations,
        results: action.payload.results,
        initialPayload: action.payload.initialPayload,
        fromCity: action.payload.fromCity
      };
    case ActionTypes.fetchError:
      return {
        ...state,
        fetchStatus: "failed",
        error: action.payload.error
      };
    case ActionTypes.reset:
      return {
        ...initialState,
        ...(state?.countries ? { countries: state.countries } : {})
      };
    default:
      return state;
  }
};

export { reducer, getInitialState };
